"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _enviro = _interopRequireDefault(require("enviro"));

// Do not remove this.
// Marketing Ops relies on this Google Tag Manager
// container to be loaded on all links that are owned by 53
var HUBSPOT_INTERNAL_PORTAL = 53;

function _default(portalId) {
  var key = 'google_analytics';

  if (portalId === HUBSPOT_INTERNAL_PORTAL && _enviro.default.deployed(key) && _enviro.default.getInternal(key) === 'prod') {
    var googleTagManager = function googleTagManager(w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      });
      var f = d.getElementsByTagName(s)[0];
      var j = d.createElement(s);
      var dl = l !== 'dataLayer' ? "&l=" + l : '';
      j.id = 'hubspot-gtm-container';
      j.async = true;
      j.src = "//www.googletagmanager.com/gtm.js?id=" + i + dl;
      f.parentNode.insertBefore(j, f);
    };

    googleTagManager(window, document, 'script', 'dataLayer', 'GTM-TDNGMT');
  }
}

module.exports = exports.default;